export default __webpack_public_path__ + "static/media/seo-click.91676a5e.svg";